import React from "react";
import { ActivityIndicator } from "react-native";
import { View, Text } from "@src/components";

interface FullScreenLoadingProps {
  /** Optional message to display below the spinner */
  message?: string;
}

/**
 * Full screen loading state with centered spinner.
 * Used when loading data for the first time (no cache available).
 */
export const FullScreenLoading: React.FC<FullScreenLoadingProps> = ({ message }) => {
  return (
    <View flex={1} bg="background" justifyContent="center" alignItems="center" gap="lg">
      <ActivityIndicator size="large" />
      {message && (
        <Text textStyle="md/regular" color="textMuted">
          {message}
        </Text>
      )}
    </View>
  );
};
